<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <newRequestForm />
  </div>
</template>

<script>
import newRequestForm from "../../components/newRequestForm";

export default {
  components: { newRequestForm }
};
</script>
